<template>
  <InvoiceMXDetail
    :s-invoice-mx-id="$route.params.idInvoice"
    @back="$router.go(-1)"
  />
</template>

<script>
import InvoiceMXDetail from "./InvoiceMXDetail.vue";

export default {
  name: "InvoiceMXView",
  components: {
    InvoiceMXDetail,
  },
};
</script>
